/**
 * Theme mode storage.
 */
export type ThemeMode = 'dark' | 'light';

export const getThemeMode = (): ThemeMode =>
  (localStorage.getItem('themeMode') as ThemeMode) || 'dark';

export const saveThemeMode = (mode: ThemeMode): void =>
  localStorage.setItem('themeMode', mode);
